import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
            Dialog, 
            DialogContent, 
            DialogContentText, 
            Typography,
            Grid,
            Button 
        } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
        textAlign : "center"
    },
    buttonSubmit: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#8DAB42'
        },
    },
    
    buttonCancel: {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
            color : 'white',
            backgroundColor : '#434041'
        },
    
    },
    dialogPaper: {
        [theme.breakpoints.up('xs')]: {
            height : '90%',
            width : "100%"
        },
        [theme.breakpoints.up('sm')]: {
            height : '70%',
            width : "40%"
        },
        [theme.breakpoints.up('md')]: {
            height : '70%',
            width : "40%"
        },
        [theme.breakpoints.up('lg')]: {
            height : '70%',
            width : "40%"
        },
        [theme.breakpoints.up('xl')]: {
            height : '70%',
            width : "40%"
        },
        
    },
    textLabel : {
        [theme.breakpoints.up('xs')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "80%"
        },
        [theme.breakpoints.up('sm')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "80%"
        },
        [theme.breakpoints.up('md')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "80%"
        },
        [theme.breakpoints.up('lg')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "80%"
        },
        [theme.breakpoints.up('xl')]: {
            color : "#706D85",
            //fontFamily : "Roboto-Bold",
            fontSize : "80%"
        },
        
    },
    textValue : {
        [theme.breakpoints.up('xs')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "100%"
        },
        [theme.breakpoints.up('sm')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "100%"
        },
        [theme.breakpoints.up('md')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "100%"
        },
        [theme.breakpoints.up('lg')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "100%"
        },
        [theme.breakpoints.up('xl')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "100%"
        },
        
    },
    textTitle : {
        [theme.breakpoints.up('xs')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('sm')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('md')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('lg')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        [theme.breakpoints.up('xl')]: {
            color : "#000000",
            //fontFamily : "Roboto-Regular",
            fontSize : "140%"
        },
        
    },
    textButtons : {
        [theme.breakpoints.up('xs')]: {
            fontSize : '60%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('md')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize : '100%',
            textAlign: 'justify',
        },
        
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid #0073D2',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        //fontFamily: 'Roboto-Medium',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid #0073D2',
        }
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
}));

const PaymentConfirmationDialog = props => {

    const classes = useStyles();

    const {
        titleDialog, 
        openDialog,
        dataTransaction,
        onHandleAcceptTransaction,
        onCloseDialogPaymentConfirmation
    } = props;


    return (
        <Dialog
            open={ openDialog }
            onClose={ onCloseDialogPaymentConfirmation }
            fullWidth={true}
            maxWidth= 'xs'
            disableBackdropClick
            disableEscapeKeyDown
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper : classes.dialogPaper}}
        >
            <DialogContent>

                <DialogContentText id="alert-dialog-description" align="center">
                    <Typography component="p" variant="p" align = "center" className = {classes.textValue}>
                        { titleDialog }
                    </Typography>
                </DialogContentText>

                    <Grid container spacing={3}>
                        <Grid item xs={6} md={6} lg={6} xl={6}>
                            <Button 
                                id={"confirm_payment_btn"}
                                variant="contained" 
                                type="submit"
                                fullWidth
                                onClick = { onHandleAcceptTransaction }
                                className = {classes.buttonStandard}
                            >
                                { "Aceptar" }
                            </Button>
                        </Grid>
                        
                        <Grid item xs={6} md={6} lg={6} xl={6}>
                            <Button 
                                variant="contained" 
                                fullWidth
                                className = {classes.buttonStandard}
                                onClick = { onCloseDialogPaymentConfirmation }
                                
                            >
                                Cancelar
                            </Button>   
                        </Grid>
                    </Grid>

                    <Grid container spacing={0}>

                        {
                            dataTransaction.map(row => (
                                <Grid item xs={12} md={12} lg={12} xl={12} className = {classes.margin} key = {row.index}>
                                    <Typography component="p" variant="p" align = "left" className = {classes.textLabel}>
                                        { row.label }
                                    </Typography>
                                    <Typography component="p" variant="p" align = "left" className = {classes.textValue}>
                                        { row.value }
                                    </Typography>
                                </Grid>
                            ))
                        }
                        
                    </Grid>
                

            </DialogContent>
        </Dialog>
    )

}

export default PaymentConfirmationDialog